/**
 * Open a URL in the system browser (or new tab in browser).
 * In Tauri shell uses opener plugin; in Electron handled by setWindowOpenHandler; in browser uses window.open.
 */

import { isInTauriShell } from './detector'

export async function openExternalUrl(url: string): Promise<void> {
  if (isInTauriShell()) {
    const { openUrl } = await import('@tauri-apps/plugin-opener')
    await openUrl(url)
  } else {
    window.open(url, '_blank')
  }
}
